export function abbreviateAmount(notional) {
    var dn = '';
   
    if (!notional) return dn;
   
    if (notional >= 1000000000) {
     //eg 1500000000 wants to be 1.5B
     var nn = (notional / 1000000000).toFixed(1);
     return ''.concat(nn, ' B');
    }

    if (notional >= 100000) {
      //eg 250000 wants to be 0.25MM
      var nn = (notional / 1000000).toFixed(1);
      if (nn.toString().endsWith('0')) nn = Math.floor(nn);
      if (notional > 100000000) nn = Math.round(nn);
      return ''.concat(nn, ' MM');
    }
   
    if (notional < 100000) {
      //eg 50000 wants to be 5M
      var nn = (notional / 10000).toFixed(1);
      return ''.concat(nn, ' M');
    }
   
    
   
    return dn;
 }

 export function formatMoney(amount) {
    const formatted = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(amount)
    return formatted
 }